import list from './clueManage'
export default list
